<template>
  <div class="max-w-2xl mx-auto px-4 dark:bg-gray-900 dark:text-gray-300">
    <VLink
      :to="{ name: 'biz' }"
      class="bg-gradient-to-r from-primary-600 to-primary-300 rounded-lg px-4 py-4 flex items-center"
    >
      <div class="me-2 text-white">
        <p class="font-display text-lg leading-none">
          {{ $t("start_shopping") }}
        </p>
        <p class="text-sm leading-none mt-1">
          {{ $t("visit_our_store") }}
        </p>
      </div>
      <Icon class="w-10 h-10 text-white ms-auto" name="RiShoppingBag3Line" />
    </VLink>
  </div>
</template>
